<template>
  <div class="banner">
    <div class="reaspnAllBox" v-show="showReason">
      <div class="reaspnBox reaspnBox03">
        <img
          :src="
            choseBtn03 === 0 ? require('../assets/img/reason/choseBtn3-2.png') : choseBtn03 === true ? require('../assets/img/reason/choseBtn3-1.png') : require('../assets/img/reason/choseBtn3-2.png')
          "
          class="choseBtn chose01"
          @click="choseReaspn03(true)"
        />
        <img
          :src="
            choseBtn03 === 0
              ? require('../assets/img/reason/choseBtn4-2.png')
              : choseBtn03 === false
              ? require('../assets/img/reason/choseBtn4-1.png')
              : require('../assets/img/reason/choseBtn4-2.png')
          "
          class="choseBtn chose02"
          @click="choseReaspn03(false)"
        />
        <img :src="sumbitBtn" alt="" class="sumbitBtn" @click="nextReaspn" @mouseenter="submitBtnActive" @mouseleave="submitBtn" />
      </div>
      <img src="../assets/img/index/机器人.gif" alt="" class="robotGif" />
    </div>
    <div class="reaspnAllBox" v-show="!reasonStatus && !showReason">
      <div class="reaspnBox">
        <img
          :src="
            choseBtn01 === 0 ? require('../assets/img/reason/choseBtn1-2.png') : choseBtn01 === true ? require('../assets/img/reason/choseBtn1-1.png') : require('../assets/img/reason/choseBtn1-2.png')
          "
          class="choseBtn chose01"
          @click="choseReaspn01(true)"
        />
        <img
          :src="
            choseBtn01 === 0
              ? require('../assets/img/reason/choseBtn2-2.png')
              : choseBtn01 === false
              ? require('../assets/img/reason/choseBtn2-1.png')
              : require('../assets/img/reason/choseBtn2-2.png')
          "
          class="choseBtn chose02"
          @click="choseReaspn01(false)"
        />
        <img :src="sumbitBtn" alt="" class="sumbitBtn" @click="nextBtn" @mouseenter="submitBtnActive" @mouseleave="submitBtn" />
      </div>
      <img src="../assets/img/index/机器人.gif" alt="" class="robotGif" />
    </div>
    <div class="reaspnAllBox" v-show="reasonStatus && !showReason">
      <div class="reaspnBox reaspnBox02">
        <img
          :src="
            choseBtn02 === 0 ? require('../assets/img/reason/choseBtn1-2.png') : choseBtn02 === true ? require('../assets/img/reason/choseBtn1-1.png') : require('../assets/img/reason/choseBtn1-2.png')
          "
          class="choseBtn chose01"
          @click="choseReaspn02(true)"
        />
        <img
          :src="
            choseBtn02 === 0
              ? require('../assets/img/reason/choseBtn2-2.png')
              : choseBtn02 === false
              ? require('../assets/img/reason/choseBtn2-1.png')
              : require('../assets/img/reason/choseBtn2-2.png')
          "
          class="choseBtn chose02"
          @click="choseReaspn02(false)"
        />
        <img :src="sumbitBtn" alt="" class="sumbitBtn" @click="nextPage" @mouseenter="submitBtnActive" @mouseleave="submitBtn" />
      </div>
      <img src="../assets/img/index/机器人.gif" alt="" class="robotGif" />
    </div>
    <div class="reasonAlterBox" @click="showReasonFuntion">
      <img src="../assets/img/reason/alterBtn.png" alt="" class="alterBtnImg" v-show="!reasonShow" />
      <div class="compareBox">
        <div class="soilBox soilOne">
          <p class="soilValue01 soilValue">{{ soilValue01 }}</p>
        </div>
        <div class="soilBox soilTwo">
          <p class="soilValue02 soilValue">{{ soilValue02 }}</p>
        </div>
      </div>
    </div>
    <audio ref="audioPlay" :loop="false">
      <source :src="oneAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayTwo" :loop="false">
      <source :src="twoAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayThree" :loop="false">
      <source :src="threeAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayFour" :loop="false">
      <source :src="fourAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayFive" :loop="false">
      <source :src="fiveAudio" type="audio/mpeg" />
    </audio>
    <img :src="homeBtnImg" class="homeBtn" @click="homeBack" @mouseenter="homeBtnActive" @mouseleave="homeBtn" />
  </div>
</template>
<script setup>
import router from "@/router";
import anime from "animejs";
import { ElMessage } from "element-plus";
import { onMounted, ref } from "vue";

import oneAudio from "../assets/audio/reason/oneAudio.mp3";
import twoAudio from "../assets/audio/reason/twoAudio.mp3";
import threeAudio from "../assets/audio/reason/threeAudio.mp3";
import fourAudio from "../assets/audio/reason/fourAudio.mp3";
import fiveAudio from "../assets/audio/reason/fiveAudio.mp3";

let audioPlay = ref();
let audioPlayTwo = ref();
let audioPlayThree = ref();
let audioPlayFour = ref();
let audioPlayFive = ref();

import sumbitBtnImg from "../assets/img/reason/submitBtn.png";
import sumbitBtnActiveImg from "../assets/img/reason/submitBtnActive.png";

import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";

// 高亮切换
let sumbitBtn = ref(sumbitBtnImg);
// 首页按钮切换
const submitBtnActive = () => {
  sumbitBtn.value = sumbitBtnActiveImg;
};
const submitBtn = () => {
  sumbitBtn.value = sumbitBtnImg;
};

// 高亮切换
let homeBtnImg = ref(home);
// 首页按钮切换
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};

let showReason = ref(true);
let reasonStatus = ref(false);

// 推论选择项
let choseBtn01 = ref(0);
let choseBtn02 = ref(0);
let choseBtn03 = ref(0);

let reasonShow = ref(false);

const nextReaspn = () => {
  audioPlayFive.value.pause();
  if (choseBtn03.value === 0) {
    ElMessage.closeAll();
    ElMessage.warning("請先進行選擇");
    return;
  }
  if (choseBtn03.value === false) {
    audioPlay.value.pause();
    audioPlayFour.value.play();
    return;
  }
  audioPlayThree.value.play();
  setTimeout(() => {
    showReason.value = false;
    audioPlayFive.value.pause();
    audioPlay.value.play();
  }, 800);
};

const nextBtn = () => {
  if (choseBtn01.value === 0) {
    ElMessage.closeAll();
    ElMessage.warning("請先進行選擇");
    return;
  }
  if (choseBtn01.value === false) {
    audioPlay.value.pause();
    audioPlayFour.value.play();
    return;
  }
  audioPlay.value.pause();
  audioPlayThree.value.play();
  setTimeout(() => {
    reasonStatus.value = true;
    audioPlay.value.pause();
    audioPlayTwo.value.play();
  }, 800);
};

const nextPage = () => {
  if (choseBtn02.value === 0) {
    ElMessage.closeAll();
    ElMessage.warning("請先進行選擇");
    return;
  }
  if (choseBtn02.value === false) {
    audioPlayTwo.value.pause();
    audioPlayFour.value.play();
    return;
  }
  audioPlayTwo.value.pause();
  audioPlayThree.value.play();
  router.push({ name: "endPage" });
};
// 选择推论
const choseReaspn01 = (value) => {
  choseBtn01.value = value;
};
const choseReaspn02 = (value) => {
  choseBtn02.value = value;
};
const choseReaspn03 = (value) => {
  choseBtn03.value = value;
};
const showReasonFuntion = () => {
  if (!reasonShow.value) {
    reasonShow.value = true;
    anime({
      targets: ".reasonAlterBox",
      translateX: [0, "-41vw"],
      duration: 800,
      easing: "linear",
    });
  } else {
    reasonShow.value = false;
    anime({
      targets: ".reasonAlterBox",
      translateX: ["-41vw", 0],
      duration: 800,
      easing: "linear",
    });
  }
};
const homeBack = () => {
  router.push({ name: "home" });
};
onMounted(() => {
  anime({
    targets: ".reasonBox",
    scale: [0, 1],
    duration: 800,
    easing: "linear",
  });
  setTimeout(() => {
    anime({
      targets: ".sumbitBtn",
      opacity: [0, 1],
      duration: 800,
      easing: "linear",
    });
  }, 800);
  audioPlayFive.value.play();
});
</script>
<style lang="scss" scoped>
.banner {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-size: 100% 100%;
  overflow: hidden;
  background-image: url(../assets/img/double/background.png);
  .reaspnAllBox {
    .reaspnBox {
      width: 60vw;
      height: 55vh;
      position: absolute;
      left: 25vw;
      top: 22vh;
      background-size: 100% 100%;
      background-image: url(../assets/img/reason/reasonBox.png);
      .choseBtn {
        width: 5.5vw;
        position: absolute;
      }
      .chose01 {
        top: 24vh;
        left: 14vw;
      }
      .chose02 {
        top: 24vh;
        left: 19vw;
      }
    }
    .reaspnBox02 {
      width: 53vw;
      background-image: url(../assets/img/reason/reasonBox02.png);
      .chose01 {
        top: 22vh;
        left: 15vw;
      }
      .chose02 {
        top: 22.2vh;
        left: 20vw;
      }
    }
    .reaspnBox03 {
      width: 53vw;
      background-image: url(../assets/img/reason/reasonBox03.png);
      .chose01 {
        top: 27.7vh;
        left: 32.7vw;
      }
      .chose02 {
        top: 27.7vh;
        left: 38vw;
      }
    }
    .sumbitBtn {
      position: absolute;
      top: 40vh;
      left: 20vw;
      width: 13vw;
      opacity: 0;
    }
    .robotGif {
      position: absolute;
      top: 48vh;
      left: 0vw;
      width: 25vw;
    }
  }
  .askBox {
    width: 50vw;
    height: 34vh;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 2.5vh 3vw;
    box-sizing: border-box;
    position: absolute;
    background-size: 100% 100%;
    left: 24vw;
    img {
      height: 10vw;
    }
  }
  .reasonAlterBox {
    width: 48vw;
    height: 64vh;
    background-image: url(../assets/img/reason/alterBackground.png);
    background-size: 100% 100%;
    position: absolute;
    top: 18vh;
    right: -44vw;
    .compareBox {
      width: 37vw;
      position: absolute;
      top: 13vh;
      left: 7vw;
      display: flex;
      justify-content: space-between;
      .soilBox {
        position: relative;
        width: 18vw;
        height: 32vh;
        top: 5vh;
        background-size: 100% 100%;
      }
      .soilOne {
        background-image: url(../assets/img/reason/result01.png);
      }
      .soilTwo {
        background-image: url(../assets/img/reason/result02.png);
      }
      .soilValue {
        font-size: 1.4vw;
        color: #fff;
        width: 5.6vw;
        text-align: center;
        margin-top: 5vh;
        margin-left: 1vw;
      }
      .weightValue {
        font-size: 1.4vw;
        color: #fff;
        width: 5.6vw;
        text-align: center;
        margin-top: 24vh;
        margin-left: 1vw;
      }
    }
    .alterBtnImg {
      position: absolute;
      top: 0;
      left: 0;
      width: 4.2vw;
      height: 19vh;
    }
  }
  .askBox01 {
    display: flex;
    justify-content: space-between;
    top: 10vh;
    background-image: url(../assets/img/reason/askBox01.png);
  }
  .askBox02 {
    top: 48vh;
    background-image: url(../assets/img/reason/askBox02.png);
  }
  .homeBtn {
    position: absolute;
    bottom: 3vh;
    right: 3vw;
    width: 4vw;
    z-index: 9;
  }
  .submitButton {
    position: absolute;
    right: 44vw;
    bottom: 6vh;
    width: 14vw;
  }
}
</style>
